module.exports = __webpack_public_path__ + "img/aiCallbot-banner.700f497c.jpg";